<template>
  <div class="allBox">
    <div v-if="importStatus == 0">
      <div v-if="sendInfo && sendInfo.type == 2">
        <div style="margin-bottom: 20px">
          <ADLIcon iconHref="i_upload_bubble" />
          {{t('views.base.org.请选择添加范围')}}
        </div>
        <div class="yearSec">
          <div>
            <span>{{t('from.学年')}}：</span>
            <a-select
              style="width: 150px"
              v-model:value="sendInfo.academicYear"
              :placeholder="t('from.请选择{name}',{name:t('from.学年')})"
            >
              <a-select-option v-for="item in academicYearList" :key="item.uid" :value="item.uid"
                >{{ item.academicYear }}
              </a-select-option>
            </a-select>
          </div>
          <div>
            <span>{{t('from.学期')}}：</span>
            <a-select
              style="width: 150px"
              v-model:value="sendInfo.academicYearSem"
              :placeholder="t('from.请选择{name}',{name:t('from.学期')})"
            >
              <a-select-option :value="11">{{t('views.base.org.春季学期')}}</a-select-option>
              <a-select-option :value="13">{{t('views.base.org.秋季学期')}}</a-select-option>
            </a-select>
          </div>
        </div>
        <a-divider style="border-color: #edeff2" dashed />
      </div>
      <div style="margin-bottom: 30px">
        <ADLIcon iconHref="i_modal_warning" />
        {{t('views.base.org.请按照模板格式进行导入，')}}<a :href="templateUrl">{{t('views.base.org.点击下载模板')}}</a>
      </div>
      <div>
        <a-upload-dragger
          :file-list="filelist"
          :before-upload="beforeUpload"
          :showUploadList="showUploadList"
          @remove="handleRemove"
          accept=".xlsx"
          style="background-color: #fff; border: none"
        >
          <p v-if="filelist.length < 1" class="ant-upload-drag-icon">
            <FolderOpenOutlined />
          </p>
          <p v-if="filelist.length < 1" class="ant-upload-text">{{t('views.base.org.点击或将文件拖拽到这里')}}</p>
          <p v-if="filelist.length < 1" class="ant-upload-hint">{{t('views.base.org.上传支持')}}：.xlsx</p>
        </a-upload-dragger>
      </div>
    </div>
    <div v-if="importStatus == 1">
      <div style="margin-top: 30px">
        <LoadingOutlined style="color: #1691f2" /> {{t('views.base.org.上传中，请稍等')}}
      </div>
      <a-progress
        style="margin: 30px 0 60px"
        :percent="percentNum"
        strokeColor="#29C175"
        :showInfo="false"
        status="active"
      />
    </div>
    <div v-if="importStatus == 2" style="font-size: 16px">
      <div v-if="showResult">
        <div style="margin: 20px 0 24px">
          <ADLIcon iconHref="i_modal_success" />
          {{t('views.base.org.创建成功')}}：{{ successCount }}{{t('from.条')}}
        </div>
        <div>
          <ADLIcon iconHref="i_modal_error" />
          {{t('views.base.org.创建失败')}}：{{ errorCount }}{{t('from.条')}}
          <span
            v-if="errorCount > 0"
            @click="downloadErrorFile"
            style="color: #3091f2; font-size: 14px; cursor: pointer"
            >{{t('views.base.org.导出失败记录')}}</span
          >
        </div>
        <div style="font-size: 12px; margin: 20px 0 28px">
          *{{t('views.base.org.部分数据创建失败，请导出失败记录，修改后重新上传。')}}
        </div>
      </div>
      <div v-else style="font-size: 16px">
        <div v-if="errorCount <= 0">
          <div style="margin: 20px 0 24px">
            <ADLIcon iconHref="i_modal_success" />
            {{t('udload.导入成功！')}}
          </div>
        </div>
        <div v-else>
          <div style="margin: 20px 0 24px">
            <ADLIcon iconHref="i_modal_error" />
            {{t('udload.导入失败！')}}
          </div>
          <span @click="downloadErrorFile" style="color: #3091f2; font-size: 14px; cursor: pointer">
            {{t('views.base.org.导出失败记录')}}
          </span>
          <div style="font-size: 12px; margin: 20px 0 28px">
            *{{t('views.base.org.部分数据创建失败，请导出失败记录，修改后重新上传。')}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <a-divider style="background-color: #edeff2" />
  <div class="btnPart">
    <a-button @click="handleReimport">{{t('from.取消')}}</a-button>
    <a-button v-if="importStatus == 0" type="primary" @click="handleImport">{{t('from.上传')}}</a-button>
    <a-button v-if="importStatus == 1" type="primary" loading>{{t('udload.上传中')}}</a-button>
    <a-button v-if="importStatus == 2" type="primary" @click="handleReimport">{{t('from.确定')}}</a-button>
  </div>
</template>

<script setup>
import { message } from 'ant-design-vue'
import { FolderOpenOutlined, LoadingOutlined } from '@ant-design/icons-vue'
import useStore from '@/store'
import { storeToRefs } from 'pinia'
import useImportBlob from '@/composables/file/useImportBlob'
import { toRefs, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()

const { dic } = useStore()
const { academicYearList } = storeToRefs(dic)
const props = defineProps({
  templateUrl: String,
  uploadUrl: String,
  sendInfo: Object,
  showResult: {
    type: Boolean,
    default: true
  }
})
const emit = defineEmits(['cancel'])

const { templateUrl, uploadUrl, sendInfo } = toRefs(props)

const percentNum = ref(0)
const interval = ref(null)

const showUploadList = { showRemoveIcon: true }
// 导入模块
const { filelist, importStatus, importFile, successCount, errorCount, blob, resultHeader } =
  useImportBlob(uploadUrl.value, sendInfo)

const beforeUpload = (file) => {
  if (
    file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    file.type === 'application/vnd.ms-excel'
  ) {
    filelist.value.push(file)
  } else {
    message.warn('只能导入Excel表格文件！')
  }

  return new Promise((reslove, reject) => {
    return reject(false)
  })
}

const handleImport = () => {
  if (sendInfo.value && sendInfo.value.type == 2) {
    if (sendInfo.value.academicYear != null && sendInfo.value.academicYearSem != null) {
      importFile()
    } else {
      message.warning('导入学生数据前请选择学年学期')
    }
  } else {
    importFile()
  }
}

const handleReimport = () => {
  importStatus.value = 0
  filelist.value = []
  handleOver()
}

const downloadErrorFile = () => {
  let downloadElement = document.createElement('a')
  let href = window.URL.createObjectURL(blob.value) //创建下载的链接
  downloadElement.href = href
  let fileName = ''
  if (resultHeader.value) {
    fileName = decodeURIComponent(resultHeader.value.split('=')[1])
  } else {
    fileName = '文件'
  }
  downloadElement.download = decodeURIComponent(fileName) //下载后文件名
  document.body.appendChild(downloadElement)
  downloadElement.click() //点击下载
  document.body.removeChild(downloadElement) //下载完成移除元素
  window.URL.revokeObjectURL(href) //释放掉blob对象
}

const handleRemove = (file) => {
  const index = filelist.value.indexOf(file)
  const newFileList = filelist.value.slice()
  newFileList.splice(index, 1)
  filelist.value = newFileList
}

const handleOver = () => {
  emit('cancel')
}

//进度条
watch(importStatus, (newVal) => {
  if (newVal == 1) {
    interval.value = setInterval(() => {
      percentNum.value = percentNum.value + 10
    }, 500)
  }
  if (newVal == 2) {
    clearInterval(interval.value)
    if (sendInfo.value && sendInfo.value.type == 2) {
      sendInfo.value.academicYear = null
      sendInfo.value.academicYearSem = null
    }
  }
})
watch(percentNum, (newVal) => {
  if (newVal >= 90) {
    clearInterval(interval.value)
  }
})
</script>
<style lang="less" scoped>
.allBox {
  font-size: 14px;
  color: #4e5661;
}
.yearSec {
  display: flex;
  justify-content: space-between;
  > div {
    width: 50%;
    > span {
      margin-right: 10px;
    }
  }
}
:deep(.ant-upload-btn) {
  padding: 0px !important;
}
.btnPart {
  display: flex;
  justify-content: flex-end;
}
</style>
